import { GET_EXERCISE, RESET_EXERCISES } from '../types';

export default (exercises = {}, action) => {
  switch(action.type) {
    case GET_EXERCISE:
      const { id, data } = action.payload;
      return { ...exercises, [id]: data };
    case RESET_EXERCISES:
      return {};
    default:
      return exercises;
  }
}
